import { memo } from 'react';

import Button from '@atlaskit/button/new';
import Tooltip from '@atlaskit/tooltip';

import { Action } from './Action';
import { ButtonOverlay, SingleActionButtonWrapper } from './styled';

export interface Props {
  isLoading?: boolean;
  action: Action;
}

const SingleActionButton = ({ isLoading, action }: Props) => {
  if (!action.isVisible) {
    return null;
  }

  return (
    <SingleActionButtonWrapper>
      <Tooltip position="left" content={!isLoading && action.disabled?.reason}>
        {!isLoading && action.disabled?.value && (
          <ButtonOverlay data-testid="button-overlay" />
        )}
        <Button
          spacing="compact"
          isDisabled={action.disabled?.value}
          isLoading={isLoading}
          onClick={action.onClick}
          testId="action-button"
        >
          {action.name}
        </Button>
      </Tooltip>
    </SingleActionButtonWrapper>
  );
};

// eslint-disable-next-line import/no-default-export
export default memo(SingleActionButton);
